module.exports = __webpack_public_path__ + "img/珠子参.8a50fac1.jpg";